export default __webpack_public_path__ + "static/media/picture-03.c3f2b490.svg";